module.exports = __webpack_public_path__ + "./images/fa54550616877bddc4308a0806d10561.webp";